module.exports = __webpack_public_path__ + "static/media/mediaBackIcon.2640825c.svg";